module.exports = __webpack_public_path__ + "static/bearteether-761dc895cccdffeb68fc3e2196303ae4.jpeg";